import { getErrorWithResponse } from './getErrorWithResponse';

export function throwErrorWithResponse(error: any, response: Response): never {
	throw getErrorWithResponse(error, response);
}
